import { css } from 'lit';
export const checkboxGroupStyles = css `
    .hlx-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        gap: var(--hlx-spacing-lg);
        margin: var(--hlx-spacing-md) 0;
    }

    .hlx-checkbox-group-column {
        flex-direction: column;
    }

    .hlx-checkbox-group-row {
        flex-direction: row;
    }

    .hlx-checkbox-group-fieldset {
        border: none;
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: 0;
    }

    .hlx-checkbox-group-error {
        margin-top: var(--hlx-spacing-md) !important;
    }

    .hlx-checkbox-group-label {
        display: block;
        color: var(--hlx-input-label-color-default);
        font-size: var(--hlx-text-font-size-md);
        font-weight: var(--hlx-text-font-weight-medium);
        line-height: var(--hlx-text-line-height-tight-1);
    }

    .hlx-checkbox-group-description {
        display: block;
        margin-top: var(--hlx-spacing-2xs);
        color: var(--hlx-input-help-text-color);
        font-size: var(--hlx-text-font-size-md);
        font-weight: var(--hlx-text-font-weight-normal);
        line-height: var(--hlx-text-line-height-tight-1);
    }
`;
//# sourceMappingURL=checkbox-group.styles.js.map